import React, { ComponentType, LazyExoticComponent } from "react";
import { Navigate, Route } from "react-router-dom";
import ProtectedRoute from "Routes/ProtectedRoute";

export type AppPageRouteConfig =
    | {
          path: string;
          component: ComponentType | LazyExoticComponent<ComponentType>;
          permission?: string;
      }
    | {
          path: string;
          redirectTo: string;
          permission?: string;
      };

export default function renderAppPageRoute(route: AppPageRouteConfig) {
    const element = "redirectTo" in route ? (
        <Navigate to={route.redirectTo} replace />
    ) : (
        <route.component />
    );

    const pageRoute = (
        <Route
            key={route.path}
            path={route.path}
            element={element}
        />
    );

    if (!route.permission) {
        return pageRoute;
    }

    return (
        <Route
            key={route.path}
            element={<ProtectedRoute requiredAccess={route.permission} />}
        >
            {pageRoute}
        </Route>
    );
}
